import { render, staticRenderFns } from "./SelectChannelModal.vue?vue&type=template&id=57a391d4&"
import script from "./SelectChannelModal.vue?vue&type=script&lang=ts&"
export * from "./SelectChannelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports